import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './CalendarCollapsedScheduleEvent.module.scss';
import { ServiceScheduleCollapseAbleEvent } from '../../../Workplace/Interfaces/ServiceScheduleEvent.interface';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { EventApi } from '@fullcalendar/react';

interface Props {
	event: EventApi;
}

const CalendarCollapsedScheduleEvent: React.FC<Props> = ({ event }) => {
	const eventRef = useRef<HTMLDivElement>(null);
	const [isExpanded, setIsExpanded] = useState(false);
	const [expandedPosition, setExpandedPosition] = useState<object>({
		left: 0,
		top: 0,
	});
	const data = event.extendedProps as ServiceScheduleCollapseAbleEvent;

	const handleCalculatePosition = () => {
		const event = eventRef.current?.getBoundingClientRect();
		if (event) {
			const positionX = event.x;
			const positionY = event.y;

			setExpandedPosition(prevValue => {
				return {
					...prevValue,
					top: positionY + 50,
					left: positionX,
					right: 'auto',
					bottom: 'auto',
					width: event.width,
				};
			});
		}
	};

	const handleMouseEnter = () => {
		if (event.extendedProps.otherCount > 0) {
			handleCalculatePosition();
			setIsExpanded(true);
		}
	};

	const handleMouseLeave = () => {
		setIsExpanded(false);
	};

	const content = (
		<div className={styles.expanded} style={expandedPosition}>
			{data.items.map(item => (
				<div
					className={styles.item}
					style={{ backgroundColor: event.backgroundColor }}>
					<div>{item.shift.label}</div>
					{item.workers.map(worker => (
						<div>{worker.name}</div>
					))}
				</div>
			))}
		</div>
	);

	const modalRoot = document.getElementById('modal-root');
	const portal = modalRoot
		? ReactDOM.createPortal(content, modalRoot)
		: undefined;

	return (
		<div className={styles.wrapper} ref={eventRef}>
			<div
				className={styles.label}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}>
				{data.label}{' '}
				{event.extendedProps.otherCount > 0 && (
					<LinkButton
						title={` +${event.extendedProps.otherCount}`}
						theme={Theme.BLUE}
					/>
				)}
			</div>
			{isExpanded && portal}
		</div>
	);
};

export default CalendarCollapsedScheduleEvent;
